import React from "react";
import { Edit, Share2, Trash2 } from "lucide-react";

export default function StudentDetailFooterActions({
  viewingStudent,
  isTeacher,
  onShare,
  onEdit,
  onDelete
}) {
  return (
    <div className="flex justify-center gap-6 mt-4 pt-6 border-t border-gray-100">
      <button onClick={() => onShare(viewingStudent)} className="flex flex-col items-center gap-1 text-gray-400 hover:text-gray-800 transition-colors group">
        <div className="p-3 rounded-full bg-gray-50 group-hover:bg-gray-100 transition-colors">
          <Share2 size={20} />
        </div>
        <span className="text-xs font-medium">공유</span>
      </button>
      {!isTeacher && (
        <>
          <button onClick={() => onEdit(viewingStudent)} className="flex flex-col items-center gap-1 text-gray-400 hover:text-blue-600 transition-colors group">
            <div className="p-3 rounded-full bg-gray-50 group-hover:bg-blue-50 transition-colors">
              <Edit size={20} />
            </div>
            <span className="text-xs font-medium">수정</span>
          </button>
          <button onClick={() => onDelete(viewingStudent.id)} className="flex flex-col items-center gap-1 text-gray-400 hover:text-rose-600 transition-colors group">
            <div className="p-3 rounded-full bg-gray-50 group-hover:bg-rose-50 transition-colors">
              <Trash2 size={20} />
            </div>
            <span className="text-xs font-medium">삭제</span>
          </button>
        </>
      )}
    </div>
  );
}
